import { getApi, postApi } from "./api";

export const GetUserWithRole = async () => {
    return await getApi(
        `/Incentive/UserListWithRole`
    );
};
export const LastUserListWithRole = async (userId) => {
    return await getApi(
        `/Incentive/LastUserListWithRole/${userId}`
    );
};
export const addIncentive = async (incentiveData) => {
    try {
        const response = await postApi(
            "/Incentive/AddIncentive",
            incentiveData
        );
        return response;

    } catch (error) {
        console(error);
        throw error.response?.data || error.message;
    }
};
export const GetIncentive = async (userId) => {
    return await getApi(
        `/Incentive/GetIncentive/${userId}`
    );
};
export const GetAllIncentive = async () => {
    return await getApi(
        `/Incentive/GetAllIncentive`
    );
};